import React, { useEffect, useState } from 'react'
import Header from '../../layouts/Header';
import { Button, Col, Dropdown, Form, FormControl, FormLabel, FormSelect, Modal, Row, Spinner, Table } from 'react-bootstrap';
import ReusableTable from '../../components/ReusableTable';
import { toast } from 'react-toastify';
import axios from '../../api/axios';
import Select from 'react-select';
import { useSelector } from 'react-redux';

const MenuIngredients = () => {

  const currentSkin = localStorage.getItem('skin-mode') ? 'dark' : '';
  const [skin, setSkin] = useState(currentSkin);
  const { access } = useSelector((state) => state.login);
  const { email } = useSelector((state) => state.login);
  const [menuAccess, setMenuAccess] = useState([]);

  console.log("Access :", access);

  useEffect(() => {
    if (Array.isArray(access)) {
      const filteredAccess = access?.filter((perm) =>
        perm?.startsWith("MenuIngredients:")
      );
      setMenuAccess(filteredAccess);
    }
  }, [access]);

  console.log("Menu Access:", menuAccess);

  const accessToken = localStorage.getItem("authToken");
  const [searchText, setSearchText] = useState('');
  const [addNewOpenModal, setAddNewOpenModal] = useState(false);
  const [ingredientsList, setIngredientsList] = useState([]);
  const [filteredData, setFilteredData] = useState([]);
  const [isLoading, setIsLoading] = useState(false);
  const [dataLoading, setDataLoading] = useState(false);
  const [categoryList, setCategoryList] = useState([]);
  const [isSubmitBtnLoading, setIsSubmitBtnLoading] = useState(false);
  const [isAddBtnLoading, setIsAddBtnLoading] = useState(false);
  const [isUdpateBtnLoading, setIsUdpateBtnLoading] = useState(false);
  const [isDeleteBtnLoading, setIsDeleteBtnLoading] = useState(false);
  const [categoryId, setCategoryId] = useState('');
  const [isClicked, setIsClicked] = useState(false);
  const [inputData, setInputData] = useState({
    product: '',
    rawMaterials: [{ rawMaterial: '', quantity: '', unit: "", addonId: "", addonValueId: "", isImportant: Boolean }],
  });
  const [editedData, setEditedData] = useState([]);
  const [rawMaterialList, setRawMaterialList] = useState([]);
  const [productsList, setProductsList] = useState([]);
  const [filteredProductList, setFilteredProductList] = useState([]);
  const [openEditModal, setOpenEditModal] = useState(false);
  const [openDeleteModal, setOpenDeleteModal] = useState(false);
  const [productIngredientId, setProductIngredientId] = useState('');
  const [page, setPage] = useState('1');
  const [rowsPerPage, setRowsPerPage] = useState('10');
  const [addons, setAddons] = useState([]);
  const [addonValues, setAddonValues] = useState([]);
  const [filteredAddonValues, setFilteredAddonValues] = useState([]);
  const [addCategoryId, setAddCategoryId] = useState('');

  const categoryOptions = categoryList?.map((cat) => ({
    value: cat._id,
    label: cat.name,
  }));

  const columns = [
    {
      header: "Sr.No",
      accessor: "serialNumber",
      render: (value, row) => (
        <div className="text-center">
          {row?.serialNumber || "----"}
        </div>
      ),
    },
    {
      header: "Menu Name & Ingredients",
      accessor: "product.name",
      render: (value, row) => {
        const accordionId = `accordion-${row.id || Math.random().toString(36).substr(2, 9)}`;

        return (
          <div className="w-100">
            {/* Accordion Header/Toggle */}
            <button
              className="btn btn-link text-decoration-none p-0 w-100 text-start"
              type="button"
              data-bs-toggle="collapse"
              data-bs-target={`#${accordionId}`}
              aria-expanded="false"
              aria-controls={accordionId}
            >
              <div className="fs-5 fw-bold mt-2 text-center" style={{ color: '#0E4961' }}>
                {row?.product?.name || "----"}
                <span className="ms-2">
                  <i className="bi bi-chevron-down"></i>
                </span>
              </div>
            </button>

            {/* Accordion Content (Collapsed by default) */}
            <div className="collapse" id={accordionId}>
              <Table striped responsive bordered className="mt-2">
                <thead>
                  <tr>
                    <th className="text-center">Sr. No</th>
                    <th className="text-center" style={{ width: '60px' }}>Raw Material</th>
                    <th className="text-center" style={{ width: '60px' }}>Addon Info</th>
                    <th className="text-center" style={{ width: '80px' }}>Quantity</th>
                  </tr>
                </thead>
                <tbody>
                  {row?.rawMaterials && row?.rawMaterials?.length > 0 ? (
                    row?.rawMaterials?.map((rm, index) => (
                      <tr key={index}>
                        <td className="text-center" style={{ width: '100px' }}>{index + 1}</td>
                        <td className="text-center fw-semibold text-primary">
                          {rm?.rawMaterial?.name || "----"}
                        </td>
                        <td className="text-center">
                          <span className="fw-semibold" style={{ fontSize: '12px', color: 'brown' }}>
                            {rm?.addonValueDetails?.value || "----"}
                          </span>
                          <br />
                          <span className="fw-bold text-success" style={{ fontSize: '10px' }}>
                            {rm?.addonId?.title || "----"}
                          </span>
                        </td>
                        <td className="text-center">{rm?.quantity || "----"} {rm?.rawMaterial?.unit || "----"}</td>
                      </tr>
                    ))
                  ) : (
                    <tr>
                      <td colSpan="4" className="text-center">No Ingredients Available</td>
                    </tr>
                  )}
                </tbody>
              </Table>
            </div>
          </div>
        );
      },
    },
    {
      header: "Actions",
      accessor: null,
      render: (_, row) => (
        <div className="d-flex justify-content-center">
          <Dropdown>
            <Dropdown.Toggle variant="link" className="p-0 m-0 border-0">
              <i className="ri-more-2-fill" style={{ cursor: "pointer", fontSize: "1.2rem" }}></i>
            </Dropdown.Toggle>
            <Dropdown.Menu align="end">
              {(menuAccess?.includes("MenuIngredients:update") || email === "contact@xpansecafe.com") && (
                <Dropdown.Item
                  className="text-primary"
                  onClick={() => handleEditModal(row)} // Uncomment and implement this function
                >
                  <i className="ri-edit-2-line me-2"></i>Edit
                </Dropdown.Item>
              )}
              {/* <Dropdown.Item
                    className="text-success"
                    // onClick={() => handleOpenViewModal(row)} // Uncomment and implement this function
                  >
                    <i className="ri-eye-line me-2"></i>View
                  </Dropdown.Item> */}
              {(menuAccess?.includes("MenuIngredients:delete") || email === "contact@xpansecafe.com") && (
                <Dropdown.Item
                  className="text-danger"
                  onClick={() => handleDeleteModal(row)} // Uncomment and implement this function
                >
                  <i className="ri-delete-bin-line me-2"></i>Delete
                </Dropdown.Item>
              )}
            </Dropdown.Menu>
          </Dropdown>
        </div>
      ),
    },
  ];

  const getIngredients = async (catId) => {
    setIsLoading(true);
    try {
      const headers = {
        Authorization: `Bearer ${accessToken}`
      }
      console.log("catId :", catId);

      const response = await axios.get("recipe", { headers });
      response?.data?.data?.recieps?.forEach((item, index) => {
        item.serialNumber = index + 1;
      });
      console.log("Response of addon ingredients :", response);

      if (catId === "" || catId === undefined) {
        setFilteredData(response?.data?.data?.recieps);
        setIngredientsList(response?.data?.data?.recieps);
      } else {
        let filteredRecipes = response?.data?.data?.recieps?.filter((rec) => rec?.product?.category === catId);
        console.log("Filtered Data :", filteredData);

        setFilteredData(filteredRecipes);
        setIngredientsList(response?.data?.data?.recieps);
      }
    } catch (error) {
      if (error.response && error.response?.data?.status === false) {
        let errorMessage = error.response.data.error;
        toast.error(errorMessage, {
          position: "top-right",
          autoClose: 3000,
          theme: "light",
        });
      }
    } finally {
      setIsLoading(false);
    }
  };

  const getCategoryList = async () => {
    try {
      const headers = {
        Authorization: `Bearer ${accessToken}`,
      };
      const response = await axios.get("masters/category/get", { headers });

      if (response?.data?.status === true) {
        setCategoryList(response?.data?.data?.categories);
      }
    } catch (error) {
      if (error.response && error.response?.data?.status === false) {
        let errorMessage = error.response.data.error;
        toast.error(errorMessage, {
          position: "top-right",
          autoClose: 3000,
          theme: "colored",
        });
      }
    }
  };

  const getProductsList = async (id) => {
    try {
      const headers = {
        Authorization: `Bearer ${accessToken}`,
      };
      const response = await axios.get("product", { headers });
      if (response?.data?.status === true) {
        console.log("Product Response :", response?.data?.data?.products);
        let filterPro = response?.data?.data?.products?.filter((cat) => cat?.category?._id === id);
        console.log("filter products :", filterPro);
        setFilteredProductList(filterPro);
        // setProductsList(response?.data?.data?.products);
      }
    } catch (error) {
      if (error.response && error.response?.data?.status === false) {
        let errorMessage = error.response.data.error;
        toast.error(errorMessage, {
          position: "top-right",
          autoClose: 3000,
          theme: "colored",
        });
      }
    }
  };

  const getProductsListForEdit = async (id) => {

    try {
      const headers = {
        Authorization: `Bearer ${accessToken}`,
      };
      const response = await axios.get("product", { headers });
      if (response?.data?.status === true) {
        console.log("Product Response :", response?.data?.data?.products);
        // let filterPro = response?.data?.data?.products?.filter((cat) => cat?.category?._id === id);
        // setFilteredProductList(filterPro);
        setProductsList(response?.data?.data?.products);
      }
    } catch (error) {
      if (error.response && error.response?.data?.status === false) {
        let errorMessage = error.response.data.error;
        toast.error(errorMessage, {
          position: "top-right",
          autoClose: 3000,
          theme: "colored",
        });
      }
    }
  };

  const getAddons = async () => {
    try {
      const headers = {
        Authorization: `Bearer ${accessToken}`
      }
      const response = await axios.get("addons?page=1&limit=1000", { headers });
      setAddons(response?.data?.data?.addons);
      console.log("Addons response :", response?.data?.data);

    } catch (error) {
      console.log("error :", error);

    }
  }

  const getRawMaterials = async () => {
    try {
      const headers = {
        Authorization: `Bearer ${accessToken}`,
      };
      // const response = await axios.get("raw-material/in-stock", { headers });
      const response = await axios.get("raw-material", { headers });


      if (response?.data?.status === true) {
        response?.data?.data?.rawMaterials?.forEach((item, index) => {
          item.serialNumber = index + 1;
        });

        setRawMaterialList(response?.data?.data?.rawMaterials);
      }
    } catch (error) {
      if (error.response && error.response?.data?.status === false) {
        let errorMessage = error.response.data.error;
        toast.error(errorMessage, {
          position: "top-right",
          autoClose: 3000,
          theme: "colored",
        });
      }
    }
  };

  const handleOpenAddModal = () => {
    setAddNewOpenModal(true);
  };

  const handleSearchChange = (e) => {
    setSearchText(e.target.value);
  };

  const handleSubmitData = async (e) => {
    e.preventDefault();
    setIsClicked(true);
    setIsSubmitBtnLoading(true);
    console.log("Category Id :", categoryId);

    await getIngredients(categoryId);
    toast.success("Data Fetched Successfully", {
      position: "top-right",
      autoClose: 3000,
      theme: "light",
    });
    setIsSubmitBtnLoading(false);
  };

  // Update product or raw materials
  const handleChange = (e) => {
    const { name, value } = e.target;
    setInputData((prevData) => ({
      ...prevData,
      [name]: value,
    }));
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setIsAddBtnLoading(true);
    try {
      const headers = {
        Authorization: `Bearer ${accessToken}`
      }

      // Prepare the payload with proper structure
      const payload = {
        product: inputData.product,
        rawMaterials: inputData.rawMaterials.map(rm => ({
          rawMaterial: rm.rawMaterial,
          quantity: rm.quantity,
          unit: rm.unit,
          addonId: rm.addonId || null,  // Send null if empty
          addonValueId: rm.addonValueId || null,  // Send null if empty
          isImportant: rm.isImportant || false
        }))
      };

      const response = await axios.post("recipe", payload, { headers });
      if (response?.data?.status === true) {
        toast.success(response?.data?.data?.message, {
          position: "top-right",
          autoClose: 3000,
          theme: "colored",
        });
        getIngredients(categoryId);

        // Reset form with all required fields
        setInputData({
          product: '',
          rawMaterials: [{
            rawMaterial: '',
            quantity: '',
            unit: '',
            addonId: '',
            addonValueId: '',
            isImportant: false
          }],
        });
        setAddNewOpenModal(false);
      }
    } catch (error) {
      let errorMessage = "";
      if (error.response?.status === 404) {
        errorMessage = error?.response?.data?.error?.message || error?.response?.data?.error;
      } else if (error.response?.status === 400) {
        errorMessage = error?.response?.data?.data?.message || error?.response?.data?.error;
      } else if (error.response?.status === 406) {
        errorMessage = error?.response?.data?.data?.message || error?.response?.data?.error;
      } else if (error.response?.status === 412) {
        errorMessage = error?.response?.data?.data?.message || error?.response?.data?.error;
      } else if (error.response?.status === 500) {
        errorMessage = error?.response?.data?.error;
      }
      toast.error(errorMessage, {
        position: "top-right",
        autoClose: 3000,
        theme: "colored",
      });
    } finally {
      setIsAddBtnLoading(false);
    }
  };

  const handleRawMaterialChange = (index, field, value) => {
    const updatedRawMaterials = [...inputData.rawMaterials];
    updatedRawMaterials[index] = {
      ...updatedRawMaterials[index],
      [field]: value
    };

    // If rawMaterial changes, update the unit as well
    if (field === 'rawMaterial' && value) {
      const selectedMaterial = rawMaterialList.find(rm => rm._id === value);
      updatedRawMaterials[index].unit = selectedMaterial?.unit || "";
    }

    // If addonId changes, clear the addonValueId
    if (field === 'addonId') {
      updatedRawMaterials[index].addonValueId = "";
    }

    setInputData({
      ...inputData,
      rawMaterials: updatedRawMaterials
    });
  };

  // Add a new raw material entry
  const addRawMaterialEntry = () => {
    setInputData((prevData) => ({
      ...prevData,
      rawMaterials: [
        ...prevData.rawMaterials,
        {
          rawMaterial: '',
          quantity: '',
          unit: '',
          addonId: '',
          addonValueId: '',
          isImportant: false
        }
      ],
    }));
  };

  const editRawMaterialEntry = () => {
    setEditedData((prevData) => ({
      ...prevData,
      rawMaterials: [
        ...prevData.rawMaterials,
        {
          rawMaterial: '',
          quantity: '',
          unit: '',
          addonId: '',
          addonValueId: '',
          isImportant: false,
          isOptional: false
        }
      ],
    }));
  };

  // Remove a raw material entry
  const removeRawMaterialEntry = (index) => {
    setInputData((prevData) => {
      const newRawMaterials = [...prevData.rawMaterials];
      newRawMaterials.splice(index, 1);

      // Ensure we always have at least one raw material entry
      if (newRawMaterials.length === 0) {
        newRawMaterials.push({
          rawMaterial: '',
          quantity: '',
          unit: '',
          addonId: '',
          addonValueId: '',
          isImportant: false
        });
      }

      return {
        ...prevData,
        rawMaterials: newRawMaterials
      };
    });
  };

  const removeEditRawMaterialEntry = (index) => {
    setEditedData((prevData) => {
      const newRawMaterials = [...prevData.rawMaterials];
      newRawMaterials.splice(index, 1);

      if (newRawMaterials.length === 0) {
        newRawMaterials.push({
          rawMaterial: '',
          quantity: '',
          unit: '',
          addonId: '',
          addonValueId: '',
          isImportant: false,
          isOptional: false
        });
      }

      return {
        ...prevData,
        rawMaterials: newRawMaterials
      };
    });
  };

  const handleEditModal = (data) => {
    console.log("Edited Data :", data);

    const mappedRawMaterials = data?.rawMaterials?.map(item => ({
      _id: item?._id,
      rawMaterial: item?.rawMaterial?._id,
      quantity: item?.quantity || '',
      unit: item?.rawMaterial?.unit || '',
      addonId: item?.addonId?._id || '',
      addonValueId: item?.addonValueId,
      isImportant: item?.isImportant || false,
      isOptional: item?.isOptional || false
    })) || [{
      rawMaterial: '',
      quantity: '',
      unit: '',
      addonId: '',
      addonValueId: '',
      isImportant: false,
      isOptional: false
    }];

    setEditedData({
      _id: data?._id,
      product: data?.product?._id || '',
      rawMaterials: mappedRawMaterials,
    });
    setOpenEditModal(true);
  };

  const handleEditRawMaterialChange = (index, field, value) => {
    const updatedRawMaterials = [...editedData.rawMaterials];

    if (field === 'rawMaterial') {
      const selectedRawMaterial = rawMaterialList.find((rm) => rm._id === value);
      updatedRawMaterials[index].rawMaterial = value;
      updatedRawMaterials[index].unit = selectedRawMaterial ? selectedRawMaterial.unit : '';
    } else {
      updatedRawMaterials[index][field] = value;
    }

    setEditedData((prevData) => ({
      ...prevData,
      rawMaterials: updatedRawMaterials,
    }));
  };

  const handleEditChange = (e) => {
    const { name, value } = e.target;
    setEditedData((prevData) => ({
      ...prevData,
      [name]: value,
    }));
  };

  const handleEditSubmit = async (e) => {
    e.preventDefault();
    setIsUdpateBtnLoading(true);

    // Validation: if addonId is filled, addonValueId must be valid
    const invalidItem = editedData.rawMaterials.find(item =>
      item.addonId?.toString().trim() !== "" && (!item.addonValueId || item.addonValueId.toString().trim() === "")
    );

    if (invalidItem) {
      toast.error("If an Addon is selected, Addon Value must also be selected.", {
        position: "top-right",
        autoClose: 3000,
        theme: "colored",
      });
      setIsUdpateBtnLoading(false);
      return;
    }

    // Sanitize addonId and addonValueId
    const sanitizedData = {
      ...editedData,
      rawMaterials: editedData.rawMaterials.map((item) => ({
        ...item,
        addonId: item.addonId?.toString().trim() === "" ? null : item.addonId,
        addonValueId: item.addonValueId?.toString().trim() === "" ? null : item.addonValueId
      }))
    };

    try {
      const headers = {
        Authorization: `Bearer ${accessToken}`
      };

      console.log("Sanitized Edited Data:", sanitizedData);

      const response = await axios.put("recipe", sanitizedData, { headers });

      if (response?.data?.status === true) {
        toast.success(response?.data?.data?.message, {
          position: "top-right",
          autoClose: 3000,
          theme: "colored",
        });
        getIngredients(categoryId);
        setOpenEditModal(false);
      }
    } catch (error) {
      let errorMessage = "";
      if (
        error.response?.status === 404 ||
        error.response?.status === 400 ||
        error.response?.status === 406 ||
        error.response?.status === 412
      ) {
        errorMessage = error?.response?.data?.data?.message || error?.response?.data?.error;
      } else if (error.response?.status === 500) {
        errorMessage = error?.response?.data?.error;
      }

      toast.error(errorMessage, {
        position: "top-right",
        autoClose: 3000,
        theme: "colored",
      });
    } finally {
      setIsUdpateBtnLoading(false);
    }
  };

  const handleDeleteModal = (data) => {
    const ingredientId = data?._id;
    setProductIngredientId(ingredientId);
    setOpenDeleteModal(true);
  }

  const handleDeleteProductIngredient = async (e) => {
    e.preventDefault();
    setIsDeleteBtnLoading(true);
    try {
      const headers = {
        Authorization: `Bearer ${accessToken}`
      }
      const data = {
        _id: productIngredientId,
      };
      const response = await axios.delete("recipe", { data, headers })
      if (response?.data?.status === true) {
        toast.success(response?.data?.data?.message, {
          position: "top-right",
          autoClose: 3000,
          theme: "colored",
        });
        getIngredients();
        setOpenDeleteModal(false);
      }
    } catch (error) {
      if (error.response && error.response?.data?.status === false) {
        let errorMessage = '';
        // error.response.data.error
        if (error.response?.status === 406) {
          errorMessage =
            error?.response?.data?.error?.message ||
            error?.response?.data?.error;
        } else if (error.response?.status === 412) {
          errorMessage = error?.response?.data?.data?.message ||
            error?.response?.data?.error;
        } else if (error.response?.status === 500) {
          errorMessage = error?.response?.data?.error;
        }
        toast.error(errorMessage, {
          position: "top-right",
          autoClose: 3000,
          theme: "colored",
        });
      }
    } finally {
      setIsDeleteBtnLoading(false);
    }
  }

  const handlePageChange = (page) => {
    // setPagination({ ...pagination, page });
    setPage(page);
  };

  const handleRowsPerPageChange = (rowsPerPage) => {
    setRowsPerPage(rowsPerPage);
    setPage(1);
  };

  // Function to get paginated data
  const getPaginatedData = () => {

    const startIndex = (page - 1) * rowsPerPage;

    const endIndex = startIndex + rowsPerPage;

    return filteredData?.slice(startIndex, endIndex);
  };


  useEffect(() => {
    getCategoryList();
    getRawMaterials();
    getProductsList();
    getProductsListForEdit();
    getAddons();
  }, []);

  useEffect(() => {
    const result = ingredientsList?.filter((item) => {
      return (
        item?.product?.name?.toLowerCase().match(searchText.toLocaleLowerCase())
      )
    });
    setFilteredData(result)
  }, [searchText]);

  return (
    <React.Fragment>
      <Header onSkin={setSkin} />
      <div className="main main-app p-3 p-lg-4">
        <div
          className="container shadow-sm"
          style={{ backgroundColor: "white" }}
        >
          <Row className="pt-4">
            <Col>
              <h5 className="fw-semibold">MENU INGREDIENTS MANAGEMENT</h5>
            </Col>
            <hr />
          </Row>

          <Row className='mt-2'>
            <Col lg="3">
              {/* <Form.Select value={categoryId} name='categoryFilter' onChange={(e) => { setCategoryId(e.target.value) }} >
                            <option value="">Select Category</option>
                            {categoryList?.map((cat) => (
                              <option key={cat?._id} value={cat._id}>
                                {cat.name}
                              </option>
                            ))}
                          </Form.Select> */}
              <Select
                name="categoryFilter"
                options={categoryOptions}
                value={categoryOptions?.find((option) => option.value === categoryId) || null}
                onChange={(selectedOption) => setCategoryId(selectedOption ? selectedOption.value : '')}
                placeholder="Select Category"
                isClearable
                classNamePrefix="react-select"
              />
            </Col>
            <Col lg="2">
              <Button className="w-100 fw-semibold" variant="success" onClick={handleSubmitData}>
                {isSubmitBtnLoading ? <Spinner size='sm' /> : "Submit"}
              </Button>
            </Col>
            <Col lg="4">
              <div className="input-group w-100">
                <input
                  type="text"
                  value={searchText}
                  onChange={handleSearchChange}
                  className="form-control"
                  placeholder="Search by menu name..."
                />
                <button className="btn btn-primary" type="button">
                  <i className="ri-search-line"></i>
                </button>
              </div>
            </Col>
            {(menuAccess?.includes("MenuIngredients:add") || email === "contact@xpansecafe.com") && (
              <Col lg="3" className="d-flex justify-content-end flex-column">
                <Button
                  variant="primary"
                  className="fw-semibold"
                  onClick={handleOpenAddModal}
                >
                  <i className="ri-add-line" style={{ marginRight: "5px" }}></i>
                  Add New Ingredients
                </Button>
              </Col>
            )}
          </Row>

          {/* <-------- Display Table ---------> */}
          {isClicked ? (
            <Row className='mt-3'>
              {(menuAccess?.includes("MenuIngredients:get") || email === "contact@xpansecafe.com") && (
                <Col>
                  <ReusableTable
                    columns={columns}
                    data={getPaginatedData()}
                    rowKey="serialNumber"
                    loading={isLoading}
                    currentPage={page}
                    recordsPerPage={rowsPerPage}
                    onPageChange={handlePageChange}
                    onRecordsPerPageChange={handleRowsPerPageChange}

                    totalPages={Math.ceil(filteredData.length / rowsPerPage)}
                  />
                </Col>
              )}
            </Row>
          ) : (
            <div
              className="d-flex justify-content-center align-items-center"
              style={{ height: "150px" }}
            >
              <h5 className="text-muted">
                Please Select Category and Click On Submit To Get The Data
              </h5>
            </div>
          )}

          {/* <-------- Add Ingredient Modal --------> */}
          {addNewOpenModal ? (
            <Modal
              size="lg"
              centered
              show={addNewOpenModal}
              onHide={() => setAddNewOpenModal(false)}
              aria-labelledby="vertically-centered-modal"
            >
              <Modal.Header closeButton>
                <Modal.Title className="fs-6">ADD MENU INGREDIENTS</Modal.Title>
              </Modal.Header>
              <Form onSubmit={handleSubmit}>
                <Modal.Body>
                  <Row>
                    <Col md="5">
                      <FormLabel className="fw-semibold">Select Category</FormLabel>
                      <FormSelect
                        id="category"
                        name="category"
                        value={addCategoryId}
                        onChange={(e) => {
                          getProductsList(e.target.value);
                          setAddCategoryId(e.target.value);
                        }}
                      >
                        <option>Select Category</option>
                        {categoryList.map((rm) => (
                          <option key={rm._id} value={rm._id}>
                            {rm.name}
                          </option>
                        ))}
                      </FormSelect>
                    </Col>
                    <Col md="7">
                      <div className="mb-3">
                        <FormLabel className="fw-semibold">
                          Select Menu <span className="text-danger">*</span>
                        </FormLabel>
                        <Select
                          options={filteredProductList?.map((rm) => ({
                            value: rm?._id,
                            label: rm?.name,
                          }))}
                          value={
                            inputData.product
                              ? {
                                value: inputData?.product,
                                label: filteredProductList?.find(
                                  (rm) => rm._id === inputData?.product
                                )?.name,
                              }
                              : null
                          }
                          onChange={(selectedOption) => {
                            handleChange({
                              target: {
                                name: "product",
                                value: selectedOption ? selectedOption.value : "",
                              },
                            });
                          }}
                          classNamePrefix="react-select"
                          isClearable
                          placeholder="Select Menu"
                        />
                      </div>
                    </Col>
                  </Row>

                  {/* Raw Materials with Addon Fields */}
                  <Row className="mt-3">
                    <Col>
                      <FormLabel className="fw-semibold">
                        Select Raw Materials <span className="text-danger">*</span>
                      </FormLabel>
                      {inputData.rawMaterials.map((entry, index) => (
                        <div key={index} className="mb-4 p-3 border rounded">
                          <Row className="mb-3 align-items-center">
                            <Col md="4">
                              <Select
                                options={rawMaterialList.map((rm) => ({
                                  value: rm._id,
                                  label: `${rm.name} ${rm.inStock === false ? "(Out of stock)" : ""}`,
                                }))}
                                value={
                                  entry.rawMaterial
                                    ? {
                                      value: entry.rawMaterial,
                                      label: rawMaterialList.find((rm) => rm._id === entry.rawMaterial)?.name,
                                    }
                                    : null
                                }
                                onChange={(selectedOption) =>
                                  handleRawMaterialChange(
                                    index,
                                    "rawMaterial",
                                    selectedOption ? selectedOption.value : ""
                                  )
                                }
                                classNamePrefix="react-select"
                                isClearable
                                placeholder="Select Raw Material"
                              />
                            </Col>
                            <Col md="3">
                              <FormControl
                                type="number"
                                placeholder="Quantity"
                                value={entry.quantity}
                                onChange={(e) =>
                                  handleRawMaterialChange(index, "quantity", e.target.value)
                                }
                              />
                            </Col>
                            <Col md="3">
                              <FormControl
                                type="text"
                                disabled
                                placeholder="Unit"
                                value={entry.unit}
                              />
                            </Col>
                            <Col xs="auto" md="2">
                              <Button
                                variant="danger"
                                onClick={() => removeRawMaterialEntry(index)}
                              >
                                Remove
                              </Button>
                            </Col>
                          </Row>

                          {/* Addon Fields for each Raw Material */}
                          <Row className="mt-3">
                            <Col md="4">
                              <FormLabel className="fw-semibold">Addon Group</FormLabel>
                              <Select
                                options={addons?.map((addon) => ({
                                  value: addon?._id,
                                  label: addon?.title,
                                }))}
                                value={
                                  entry.addonId
                                    ? {
                                      value: entry.addonId,
                                      label: addons?.find((a) => a?._id === entry.addonId)?.title,
                                    }
                                    : null
                                }
                                onChange={(selectedOption) => {
                                  handleRawMaterialChange(
                                    index,
                                    "addonId",
                                    selectedOption?.value || ""
                                  );
                                }}
                                classNamePrefix="react-select"
                                isClearable
                                placeholder="Select Addon Group"
                              />
                            </Col>
                            <Col md="4">
                              <FormLabel className="fw-semibold">Addon Value</FormLabel>
                              <Select
                                options={
                                  entry.addonId
                                    ? addons
                                      .find(a => a._id === entry.addonId)
                                      ?.addonValues
                                      ?.map(val => ({
                                        value: val._id,
                                        label: val.value,
                                        // You can add additional properties if needed
                                        // For example, if you want to show status:
                                        // isDisabled: val.status === "INACTIVE"
                                      })) || []
                                    : []
                                }
                                value={
                                  entry.addonValueId && entry.addonId
                                    ? {
                                      value: entry.addonValueId,
                                      label: addons
                                        .find(a => a._id === entry.addonId)
                                        ?.addonValues
                                        ?.find(v => v._id === entry.addonValueId)
                                        ?.value || "Unknown Value"
                                    }
                                    : null
                                }
                                onChange={(selectedOption) => handleRawMaterialChange(
                                  index,
                                  "addonValueId",
                                  selectedOption?.value || ""
                                )}
                                classNamePrefix="react-select"
                                isClearable
                                placeholder={entry.addonId ? "Select Addon Value" : "Select Addon Group first"}
                                isDisabled={!entry.addonId}
                                noOptionsMessage={() => entry.addonId ? "No addon values available" : "Please select an Addon Group"}
                              />
                            </Col>
                            <Col md="4" className="d-flex align-items-center">
                              <Form.Check
                                type="checkbox"
                                label="Is Important"
                                name={`isImportant-${index}`}
                                checked={entry.isImportant || false}
                                onChange={(e) =>
                                  handleRawMaterialChange(
                                    index,
                                    "isImportant",
                                    e.target.checked
                                  )
                                }
                                className="mt-4 fw-semibold"
                              />
                            </Col>
                          </Row>
                        </div>
                      ))}
                      <Button
                        variant="success"
                        className="mt-2"
                        onClick={addRawMaterialEntry}
                      >
                        <i className="ri-add-line" style={{ marginRight: "5px" }}></i> Add More
                      </Button>
                    </Col>
                  </Row>
                </Modal.Body>
                <Modal.Footer>
                  <Button
                    variant="primary"
                    type="submit"
                    disabled={isAddBtnLoading}
                  >
                    {isAddBtnLoading ? (
                      <>
                        <Spinner
                          as="span"
                          animation="border"
                          size="sm"
                          role="status"
                          aria-hidden="true"
                        />
                        <span className="ms-2">Loading...</span>
                      </>
                    ) : (
                      "ADD PRODUCT INGREDIENTS"
                    )}
                  </Button>
                </Modal.Footer>
              </Form>
            </Modal>
          ) : null}

          {/* <-------- Update Ingredient Modal --------> */}
          {openEditModal ? (
            <Modal size="lg" centered show={openEditModal} onHide={() => setOpenEditModal(false)}>
              <Modal.Header closeButton>
                <Modal.Title className="fs-6">EDIT PRODUCT INGREDIENTS</Modal.Title>
              </Modal.Header>
              <Form onSubmit={handleEditSubmit}>
                <Modal.Body>
                  <Row>
                    <Col>
                      <div className="mb-3">
                        <FormLabel className="fw-semibold">
                          Select Product <span className="text-danger">*</span>
                        </FormLabel>
                        <Select
                          options={productsList?.map((product) => ({
                            value: product._id,
                            label: product.name,
                          }))}
                          value={
                            editedData.product
                              ? {
                                value: editedData.product,
                                label: productsList?.find(
                                  (product) => product?._id === editedData?.product
                                )?.name,
                              }
                              : null
                          }
                          onChange={(selectedOption) => {
                            handleEditChange({
                              target: {
                                name: "product",
                                value: selectedOption ? selectedOption.value : "",
                              },
                            });
                          }}
                          classNamePrefix="react-select"
                          isClearable
                          placeholder="Select Product"
                        />
                      </div>
                    </Col>
                  </Row>

                  <Row>
                    <Col>
                      <FormLabel className="fw-semibold">
                        Select Raw Materials <span className="text-danger">*</span>
                      </FormLabel>
                      {editedData?.rawMaterials?.map((entry, index) => (
                        <div key={index} className="mb-4 p-3 border rounded">
                          <Row className="mb-3 align-items-center">
                            <Col md="4">
                              <Select
                                options={rawMaterialList?.map((rm) => ({
                                  value: rm._id,
                                  label: `${rm.name} ${rm?.inStock === false ? "(Out of stock)" : ""}`,
                                }))}
                                value={
                                  entry?.rawMaterial
                                    ? {
                                      value: entry?.rawMaterial,
                                      label: rawMaterialList?.find(
                                        (rm) => rm._id === entry.rawMaterial
                                      )?.name,
                                    }
                                    : null
                                }
                                onChange={(selectedOption) =>
                                  handleEditRawMaterialChange(
                                    index,
                                    "rawMaterial",
                                    selectedOption ? selectedOption.value : ""
                                  )
                                }
                                classNamePrefix="react-select"
                                isClearable
                                placeholder="Select Raw Material"
                              />
                            </Col>
                            <Col md="2">
                              <FormControl
                                type="number"
                                placeholder="Quantity"
                                value={entry.quantity || ""}
                                onChange={(e) =>
                                  handleEditRawMaterialChange(index, "quantity", e.target.value)
                                }
                              />
                            </Col>
                            <Col md="2">
                              <FormControl
                                type="text"
                                disabled
                                placeholder="Unit"
                                value={entry.unit || ""}
                              />
                            </Col>
                            {/* <Col md="2" className="d-flex align-items-center">
                                        <Form.Check
                                          type="checkbox"
                                          label="Optional"
                                          name={`isOptional-${index}`}
                                          checked={entry.isOptional || false}
                                          onChange={(e) =>
                                            handleEditRawMaterialChange(
                                              index,
                                              "isOptional",
                                              e.target.checked
                                            )
                                          }
                                        />
                                      </Col> */}
                            <Col md="2" className="d-flex align-items-center">
                              <Button
                                variant="danger"
                                onClick={() => removeEditRawMaterialEntry(index)}
                              >
                                Remove
                              </Button>
                            </Col>
                          </Row>

                          {/* Addon Fields */}
                          <Row className="mt-3">
                            <Col md="4">
                              <FormLabel className="fw-semibold">Addon Group</FormLabel>
                              <Select
                                options={addons?.map((addon) => ({
                                  value: addon?._id,
                                  label: addon?.title,
                                }))}
                                value={entry?.addonId ? {
                                  value: entry?.addonId,
                                  label: addons?.find((a) => a?._id === entry?.addonId)?.title,
                                }
                                  : null
                                }
                                onChange={(selectedOption) => {
                                  handleEditRawMaterialChange(index, "addonId", selectedOption?.value || "");
                                  handleEditRawMaterialChange(index, "addonValueId", "");
                                }}
                                classNamePrefix="react-select"
                                isClearable
                                placeholder="Select Addon Group"
                              />
                            </Col>
                            <Col md="4">
                              <FormLabel className="fw-semibold">Addon Value</FormLabel>
                              <Select
                                options={
                                  entry.addonId
                                    ? addons?.find(a => a._id === entry.addonId)?.addonValues?.map(val => ({
                                      value: val?._id,
                                      label: val?.value,
                                    })) || []
                                    : []
                                }
                                value={
                                  entry?.addonValueId && entry?.addonId
                                    ? {
                                      value: entry?.addonValueId,
                                      label: addons?.find(a => a?._id === entry?.addonId)?.addonValues?.find(v => v?._id === entry?.addonValueId)?.value || "Unknown Value"
                                    }
                                    : null
                                }
                                onChange={(selectedOption) =>
                                  handleEditRawMaterialChange(index, "addonValueId", selectedOption?.value || "")
                                }
                                classNamePrefix="react-select"
                                isClearable
                                placeholder={entry.addonId ? "Select Addon Value" : "Select Addon Group first"}
                                isDisabled={!entry.addonId}
                              />
                            </Col>
                            <Col md="4" className="d-flex align-items-center">
                              <Form.Check
                                type="checkbox"
                                label="Is Important"
                                name={`isImportant-${index}`}
                                checked={entry.isImportant || false}
                                onChange={(e) =>
                                  handleEditRawMaterialChange(
                                    index,
                                    "isImportant",
                                    e.target.checked
                                  )
                                }
                              />
                            </Col>
                          </Row>
                        </div>
                      ))}
                      <Button
                        variant="success"
                        className="mt-2"
                        onClick={editRawMaterialEntry}
                      >
                        <i className="ri-add-line" style={{ marginRight: "5px" }}></i> Add More
                      </Button>
                    </Col>
                  </Row>
                </Modal.Body>
                <Modal.Footer>
                  <Button variant="primary" type="submit" disabled={isUdpateBtnLoading}>
                    {isUdpateBtnLoading ? (
                      <>
                        <Spinner as="span" animation="border" size="sm" role="status" />
                        <span className="ms-2">Loading...</span>
                      </>
                    ) : (
                      "UPDATE PRODUCT INGREDIENT"
                    )}
                  </Button>
                </Modal.Footer>
              </Form>
            </Modal>
          ) : null}

          {/* <-------- Delete Outlet Modal ------------> */}
          {openDeleteModal && (
            <Modal show={openDeleteModal} onHide={() => setOpenDeleteModal(false)} centered>
              <Modal.Header closeButton>
                <Modal.Title>Confirm Delete</Modal.Title>
              </Modal.Header>
              <Modal.Body>
                Are you sure you want to delete this Ingredient? This action cannot be undone.
              </Modal.Body>
              <Modal.Footer>
                <Button variant="secondary" onClick={() => setOpenDeleteModal(false)}>
                  Cancel
                </Button>
                <Button variant="danger" onClick={handleDeleteProductIngredient}>
                  {isDeleteBtnLoading ?
                    <Spinner
                      as="span"
                      animation="border"
                      size="sm"
                      role="status"
                      aria-hidden="true"
                    /> :
                    "Delete Ingredient"
                  }
                </Button>
              </Modal.Footer>
            </Modal>
          )}
        </div>
      </div>
    </React.Fragment>
  )
}

export default MenuIngredients